import React from "react";
import "./ProductCard.scss";

interface ProductCardProps {
  id: number;
  article: string;
  title: string;
  image: string;
  amount: number;
  remains_storage?: number;
  remains_storage_tdm?: number;
  price: number;
  price_retail: number
  onDelete: (id: number) => void;
  onIncreaseAmount: (id: number) => void;
  onDecreaseAmount: (id: number) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  id,
  article,
  title,
  image,
  amount,
  remains_storage,
  remains_storage_tdm,
  onDelete,
  onIncreaseAmount,
  onDecreaseAmount,
  price,
  price_retail
}) => {

  return (
    <div className="product-card">
      <div className="product-details">
        <h2 className="product-title">{title}</h2>
        <p className="product-article">{article}</p>
        <p className="product-price">
          <span className="bold">Цена:</span> {price_retail}
        </p>
        <p className="product-stock">
          <span className="bold">Остаток склада:&nbsp;</span>
          {remains_storage !== null && remains_storage !== undefined ? (
            remains_storage
          ) : (
            <span className="no-stock">Нет в наличии</span>
          )}
        </p>
        <p className="product-stock">
          <span className="bold">Остаток магазина:&nbsp;</span>
          {remains_storage_tdm !== null && remains_storage_tdm !== undefined ? (
            remains_storage_tdm
          ) : (
            <span className="no-stock">Нет в наличии</span>
          )}
        </p>
        <div className="product-amount">
          <button onClick={() => onDecreaseAmount(id)}>-</button>
          <span>{amount}</span>
          <button onClick={() => onIncreaseAmount(id)}>+</button>
        </div>
      </div>
      <div className="product-image">
        <img src={image} alt={title} />
      </div>
      <button className="delete-button" onClick={() => onDelete(id)}>
        X
      </button>
    </div>
  );
};

export default ProductCard;
